import { ReactNode } from 'react';

interface ErrorMessageProps {
  children: ReactNode;
}

/**
 * ErrorMessage Component - Componente reutilizável para exibir mensagens de erro
 *
 * @example
 * ```tsx
 * <ErrorMessage>Erro ao fazer login</ErrorMessage>
 * ```
 */
export const ErrorMessage = ({ children }: ErrorMessageProps) => {
  if (!children) return null;

  return (
    <div
      className="bg-[rgba(229,57,53,0.12)] border border-[#e53935] rounded-lg p-4"
      role="alert"
      aria-live="assertive"
    >
      <p className="text-[#e53935] text-sm">{children}</p>
    </div>
  );
};
